import { API_BASE_URL, apiFetch } from '@/lib/api/http';

/** 採点（指示書 §5.1・§10・§12 M9 / DECISIONS D-035〜D-037）. */
export interface ScoreRankingEntry {
  member_id: string;
  member_name: string | null;
  photo_url: string | null;
  cohort_name: string | null;
  course_name: string | null;
  status: string | null;
  specialty: string | null;
  rank: number;
  score: number;
  /** 前月比（正=上昇・負=下降・0=変わらず）。前月の公開が無ければ null で「—」表示 */
  rank_delta: number | null;
}

export interface ScoreDetail {
  member_id: string;
  member_name: string | null;
  period: string;
  rank: number;
  score: number;
  components: Record<string, unknown>;
}

export type ScoreVersionStatus = 'imported' | 'published' | 'rolled_back';

export const SCORE_VERSION_STATUS_LABELS: Record<ScoreVersionStatus, string> = {
  imported: '取込済み（未公開）',
  published: '公開済み',
  rolled_back: 'ロールバック済み',
};

export interface ScoreVersion {
  id: string;
  period: string;
  calculation_version: string;
  status: ScoreVersionStatus;
  published_at: string | null;
  rolled_back_at: string | null;
  created_at: string;
}

export function fetchScorePeriods(): Promise<string[]> {
  return apiFetch<string[]>('/scores/periods');
}

export function fetchScoreRanking(period: string): Promise<ScoreRankingEntry[]> {
  return apiFetch<ScoreRankingEntry[]>(`/scores/ranking?period=${encodeURIComponent(period)}`);
}

export function fetchScoreDetail(period: string, memberId?: string): Promise<ScoreDetail> {
  const params = new URLSearchParams({ period });
  if (memberId) params.set('member_id', memberId);
  return apiFetch<ScoreDetail>(`/scores/detail?${params.toString()}`);
}

export function fetchScoreVersions(period: string): Promise<ScoreVersion[]> {
  return apiFetch<ScoreVersion[]>(`/scores/versions?period=${encodeURIComponent(period)}`);
}

export function publishScoreVersion(versionId: string): Promise<ScoreVersion> {
  return apiFetch<ScoreVersion>(`/scores/versions/${versionId}/publish`, { method: 'POST' });
}

export function rollbackScoreVersion(period: string): Promise<ScoreVersion> {
  return apiFetch<ScoreVersion>(`/scores/rollback?period=${encodeURIComponent(period)}`, {
    method: 'POST',
  });
}

export function scoreRawExportUrl(period: string): string {
  return `${API_BASE_URL}/csv/score-raw-export?period=${encodeURIComponent(period)}`;
}
